<!--
 * @Description: 关联项目
 * @Date: 2024-02-03 15:02:27
-->
<template>
  <BaseDialog width="960px" title="关联项目">
    <BaseTextContent>
      <XrkTable
        ref="xrkTableRef"
        :getListAjax="getListAjax"
        :searchConfig="searchConfig"
        :tableConfig="tableConfig"
        :requestNow="true"
        :paginationConfig="{
          paginationPageSize: 15
        }"
      ></XrkTable>
    </BaseTextContent>

    <template #footer>
      <BaseButton type="default" @click="onCancel">关闭</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="tsx" setup>
import { ref, withDefaults, defineProps } from 'vue';

import {
  XrkTable,
  useTableColumn,
  XrkTableRef,
  useInputColumn,
  useSelectColumn,
  BaseDialog,
  BaseTextContent,
  BaseButton
} from 'xrk-components';

import {
  relateProjects,
  customerSelectList
} from '@V/bi-tmpl/src/data-source/apis';

import { date } from '@/utils/formatter';

const props = withDefaults(
  defineProps<{
    remove?: () => {};
    id: number;
  }>(),
  {}
);

const xrkTableRef = ref<XrkTableRef>(null);

const getListAjax = async params => {
  const resp = await relateProjects({
    ...params,
    templateId: props.id
  });
  return resp;
};
const searchConfig = {
  searchColumns: [
    useInputColumn({
      prop: 'projectName',
      type: 'input',
      label: '项目名称',
      style: {
        width: '155px'
      },
      config: {
        placeholder: '请输入项目名称',
        clearable: true
      }
    }),
    useSelectColumn({
      prop: 'customerEntId',
      label: '客户企业',
      style: {
        width: '155px'
      },
      config: {
        placeholder: '请选择客户企业',
        clearable: true,
        filterUseRemote: true,
        remoteMethod: async (val: string) => {
          return await customerSelectList({
            keyword: val,
            templateId: props.id,
            pageNo: 1,
            pageSize: 50
          });
        },
        labelKey: 'customerEntName',
        valueKey: 'customerEntId'
      }
    })
  ],
  resetBtn: {
    show: true,
    text: '重置'
  }
};
const tableConfig = {
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    useTableColumn({
      label: '项目名称',
      prop: 'projectName',
      showOverflowTooltip: false
    }),
    useTableColumn({
      label: '项目周期',
      prop: 'startDt',
      width: '210px',
      render({ row }) {
        return (
          <span>
            {date(row.startDt, 'date')} - {date(row.endDt, 'date')}
          </span>
        );
      }
    }),
    useTableColumn({
      label: '客户企业',
      prop: 'customerEntName',
      showOverflowTooltip: false
    })
  ].filter(i => !!i)
};

const onCancel = () => {
  props?.remove?.();
};
</script>
